import { useEffect, useState } from "react"
import moment from "moment-timezone"
import { get } from "helpers/api_helper"

export const penaltyTypes = { ANNOUNCED_WITHDRAWAL: "Announced withdrawal", LATE_WITHDRAWAL: "Late withdrawal", NO_SHOW: "No show", ADMINISTRATIVE_PENALTY: "Administrative penalty" }
export const penaltyStates = { ENABLED: "Active record", DISABLED: "Deactivated", DELETED: "Cancelled" }
export const penaltyEffects = { active: "Registration ban in effect", scheduled: "Registration ban scheduled", expired: "Registration ban expired", none: "Penalty recorded — No registration ban", inactive: "Registration ban inactive", cancelled: "Cancelled", unknown: "Registration ban not verified" }
export const penaltyDate = (date, timezone) => date && moment(date).isValid() ? moment(date).tz(timezone || "UTC").format("DD MMM YYYY, HH:mm") : "Unknown date"
export const penaltyLocation = location => location?.city || location?.name || "Location unavailable"
export const penaltyUrl = competitionId => "/admin/competition-penalties/" + competitionId
export function usePenaltyRead(url, params = {}, shape = "registry", refreshKey = 0) {
  const query = JSON.stringify(params), key = url + query
  const [state, setState] = useState({}), [version, reload] = useState(0)
  useEffect(() => {
    let current = true
    setState({ key, loading: true })
    get(url, { params: JSON.parse(query) }).then(result => {
      const data = result.data, competitionId = url.split("/")[3]
      const scope = data?.competitionId || data?.context?.competitionId
      const validCount = Number.isSafeInteger(data?.length) && data.length >= 0
      const valid = shape === "incidents" ? scope === competitionId && Array.isArray(data?.items) && validCount
        : shape === "incident" ? scope === competitionId && data?.incident?.id === url.split("/")[5]
        : shape === "penaltyLogs" ? data?.penaltyId === url.split("/")[3] && Array.isArray(data?.items) && validCount
        : shape === "logs" ? Array.isArray(data?.items) && validCount
        : shape === "context" ? scope === competitionId && Array.isArray(data?.participants)
        : shape === "detail" ? scope === competitionId && data?.penalty?._id === url.split("/")[4]
        : scope === competitionId && Array.isArray(data?.penalties) && validCount
      if (result.success === false || !valid) throw new Error("Invalid penalty response")
      if (current) setState({ key, data: result.data })
    }).catch(() => { if (current) setState({ key, error: true }) })
    return () => { current = false }
  }, [url, query, key, version, shape, refreshKey])
  return { ...(state.key === key ? state : { loading: true }), reload: () => reload(v => v + 1) }
}
